"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.chnMep = void 0;

var util_1 = require("../../util");

var breakpoints_json_1 = __importDefault(require("./breakpoints.json"));
/**
 * AQI (CN)
 * @see https://kjs.mep.gov.cn/hjbhbz/bzwb/dqhjbh/jcgfffbz/201203/t20120302_224166.htm
 */


exports.chnMep = __assign({
  displayName: 'AQI (CN)'
}, util_1.createAqiFromBreakpoints('chnMep', breakpoints_json_1["default"]));